// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// live.LZSCR.cz
export const XfirebaseConfig = {
  apiKey: "AIzaSyAXqGGWiBPca8g1eUGRKoOaex66egVxMRk",
  authDomain: "live-lzscr.firebaseapp.com",
  databaseURL: "https://live-lzscr-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "live-lzscr",
  storageBucket: "live-lzscr.appspot.com",
  messagingSenderId: "770954490244",
  appId: "1:770954490244:web:4745aca94c6372a746edd1"
};

// dev.lzscr.cz
export const firebaseConfig = {
  apiKey: "AIzaSyAgcMAFue9mo4oKcfSUhWuSpdDFwD0jZNM",
  authDomain: "dev-lzscr.firebaseapp.com",
  databaseURL: "https://dev-lzscr-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "dev-lzscr",
  storageBucket: "dev-lzscr.appspot.com",
  messagingSenderId: "431144865272",
  appId: "1:431144865272:web:026b1b2944636b22c31a0d"
};